import Checkbox from './Checkbox.component';

export default Checkbox;
